export default {
	exams: 'Exams',
	'go-to-exam': 'Go to exam',

	'no-exams': 'No exams. Stay tuned!',
	'exam-today': 'Exam is today!',
	'next-exam': 'Next exam is due in',
}